export default __webpack_public_path__ + "static/media/pr_c_22.1e73feda.jpg";